import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatCurrency } from "@/utils/formatCurrency";
import { getPairColor, PairExposure } from "@trader-dashboard/shared";

type DrawdownPairTableProps = {
  exposures: PairExposure[];
  referencePips: number;
};

export const DrawdownPairTable = ({
  exposures,
  referencePips,
}: DrawdownPairTableProps): React.ReactNode => {
  if (exposures.length === 0) return null;

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Pair</TableHead>
            <TableHead className="text-right">Positions</TableHead>
            <TableHead className="text-right">Lots</TableHead>
            <TableHead className="text-right">Floating P/L</TableHead>
            <TableHead className="text-right">Loss at {referencePips}p</TableHead>
            <TableHead className="text-right">At stops</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {exposures.map((exposure) => (
            <TableRow key={exposure.pair}>
              <TableCell>
                <span className="flex items-center gap-2 font-medium">
                  <span
                    className="h-1 w-4 rounded-full"
                    style={{ backgroundColor: getPairColor(exposure.pair) }}
                  />
                  {exposure.pair}
                </span>
              </TableCell>
              <TableCell className="text-right tabular-nums">{exposure.positions}</TableCell>
              <TableCell className="text-right tabular-nums">{exposure.lots.toFixed(2)}</TableCell>
              <TableCell
                className={`text-right tabular-nums ${
                  exposure.floatingProfit < 0 ? "text-red-600" : "text-green-600"
                }`}
              >
                {formatCurrency(exposure.floatingProfit)}
              </TableCell>
              <TableCell className="text-right tabular-nums text-red-600">
                {exposure.scenarioLoss === null ? "—" : formatCurrency(exposure.scenarioLoss)}
              </TableCell>
              <TableCell className="text-right tabular-nums">
                {exposure.stopLoss === null ? (
                  <span className="text-amber-600">
                    {exposure.ordersWithoutStop} unprotected
                  </span>
                ) : (
                  <span className="text-red-600">{formatCurrency(exposure.stopLoss)}</span>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
